export default function setDocumentTitle(text) {
  if(typeof document !== "undefined") {
    document.title = "LobbyView | " + text
  }
}
